import { Component } from 'react'
import { ReactComponent as PromoCodeIcon } from './promo_code.svg'
import './PromoCodeInfo.scss'
import { translateManager as t } from 'services/TranslateManager'

class PromoCodeInfo extends Component {
  render() {
    const { title, subtitle, showIcon } = this.props
    return (
      <div className="PromoCodeInfo">
        {showIcon && (
          <div className="promo-icon">
            <PromoCodeIcon />
          </div>
        )}
        <div className="promo-content">
          <p className="title text" data-testid="promo-code-info-title">
            {t.get('order.checkout.promo.title')}: {title}
          </p>
          {subtitle && <p className="subtitle text">{subtitle}</p>}
        </div>
        {this.props.canCancel && (
          <div className="promo-cancel" onClick={this.props.cancel}>
            {t.get('general.cancel')}
          </div>
        )}
      </div>
    )
  }
}

export default PromoCodeInfo
